module.exports = __webpack_public_path__ + "simquadrat-bottom.svg?0f0274d97e2012ecc770a33bd351922b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/simquadrat-bottom.svg
// module id = 78
// module chunks = 0